import {useCallback, useLayoutEffect, useRef, useState} from "react";

type PillIndicatorStyle = {
    height: number;
    left: number;
    top: number;
    visible: boolean;
    width: number;
};

const initialStyle: PillIndicatorStyle = {
    height: 0,
    left: 0,
    top: 0,
    visible: false,
    width: 0
};

export const usePillIndicator = (activeIndex: number) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const tabRefs = useRef<(HTMLElement | null)[]>([]);
    const [indicatorStyle, setIndicatorStyle] = useState<PillIndicatorStyle>(initialStyle);
    const [isIndicatorReady, setIsIndicatorReady] = useState(false);
    const [isAnimated, setIsAnimated] = useState(false);

    const setTabRef = useCallback(
        (index: number) => (node: HTMLElement | null) => {
            tabRefs.current[index] = node;
        },
        []
    );

    const updateIndicator = useCallback(() => {
        const container = containerRef.current;
        const activeTab = activeIndex >= 0 ? tabRefs.current[activeIndex] : null;

        if (!container || !activeTab) {
            setIndicatorStyle((current) => ({...current, visible: false}));

            return;
        }

        const containerRect = container.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();

        setIndicatorStyle({
            height: tabRect.height,
            left: tabRect.left - containerRect.left,
            top: tabRect.top - containerRect.top,
            visible: true,
            width: tabRect.width
        });
    }, [activeIndex]);

    useLayoutEffect(() => {
        updateIndicator();
        setIsIndicatorReady(true);

        const animationFrameId = requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setIsAnimated(true);
            });
        });

        const container = containerRef.current;

        if (!container) {
            return () => cancelAnimationFrame(animationFrameId);
        }

        const resizeObserver = new ResizeObserver(updateIndicator);

        resizeObserver.observe(container);
        tabRefs.current.forEach((tab) => {
            if (tab) {
                resizeObserver.observe(tab);
            }
        });

        return () => {
            cancelAnimationFrame(animationFrameId);
            resizeObserver.disconnect();
        };
    }, [updateIndicator]);

    return {containerRef, indicatorStyle, isAnimated, isIndicatorReady, setTabRef};
};
import {useCallback, useLayoutEffect, useRef, useState} from "react";

type PillIndicatorStyle = {
    height: number;
    left: number;
    top: number;
    visible: boolean;
    width: number;
};

const initialStyle: PillIndicatorStyle = {
    height: 0,
    left: 0,
    top: 0,
    visible: false,
    width: 0
};

export const usePillIndicator = (activeIndex: number) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const tabRefs = useRef<(HTMLElement | null)[]>([]);
    const [indicatorStyle, setIndicatorStyle] = useState<PillIndicatorStyle>(initialStyle);
    const [isIndicatorReady, setIsIndicatorReady] = useState(false);
    const [isAnimated, setIsAnimated] = useState(false);

    const setTabRef = useCallback(
        (index: number) => (node: HTMLElement | null) => {
            tabRefs.current[index] = node;
        },
        []
    );

    const updateIndicator = useCallback(() => {
        const container = containerRef.current;
        const activeTab = activeIndex >= 0 ? tabRefs.current[activeIndex] : null;

        if (!container || !activeTab) {
            setIndicatorStyle((current) => ({...current, visible: false}));

            return;
        }

        const containerRect = container.getBoundingClientRect();
        const tabRect = activeTab.getBoundingClientRect();

        setIndicatorStyle({
            height: tabRect.height,
            left: tabRect.left - containerRect.left,
            top: tabRect.top - containerRect.top,
            visible: true,
            width: tabRect.width
        });
    }, [activeIndex]);

    useLayoutEffect(() => {
        updateIndicator();
        setIsIndicatorReady(true);

        const animationFrameId = requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setIsAnimated(true);
            });
        });

        const container = containerRef.current;

        if (!container) {
            return () => cancelAnimationFrame(animationFrameId);
        }

        const resizeObserver = new ResizeObserver(updateIndicator);

        resizeObserver.observe(container);
        tabRefs.current.forEach((tab) => {
            if (tab) {
                resizeObserver.observe(tab);
            }
        });

        return () => {
            cancelAnimationFrame(animationFrameId);
            resizeObserver.disconnect();
        };
    }, [updateIndicator]);

    return {containerRef, indicatorStyle, isAnimated, isIndicatorReady, setTabRef};
};
